export default {"src":"/_next/static/media/square_icon.4b190c58.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};